import * as types from '../const/action.types';
import { get } from '../api/_basic';

export function reportsSTSIsLoading(bool) {
    return {
        type: types.REPORT_STS_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsSTSFieldsFetchDataSuccess(items) {
    return {
        type: types.REPORT_STS_FETCH_DATA,
        items,
    };
}

export function loadSTS(local, from, to, name) {
    return async (dispatch) => {
        dispatch(
            reportsSTSFieldsFetchDataSuccess({
                from: from,
                to: to,
                local: local,
                name: name,
            }),
        );
        dispatch(reportsSTSIsLoading(true));
        try {
            let url = `${process.env.REACT_APP_API_LOCAL}/${local}/comentariossts`;
            if (from) {
                url = url + '?inicio=' + from;
            }
            if (to) {
                url = url + (from ? '&fin=' : '?fin=') + to;
            }
            const response = await get(url);
            dispatch(reportsSTSIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const field = {
                from: from,
                to: to,
                local: local,
                name: name,
                values: response,
            };
            dispatch(reportsSTSFieldsFetchDataSuccess(field));
        } catch (error) {
            dispatch(reportsSTSIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.sts.actions.js